import { LayoutDefault } from '../../router/templates/default';
import styles from './style.module.scss';
import getFormatMessage from '../../locales/get-format-message';
import { getLocaleLanguage, LanguageType } from '../../lib';
import { ProductsBanner } from './products-banner';
import { useEffect, useState } from 'react';
import { IJsonConfig, IProductsServiceItem } from '../../model/products';
import { useHistory } from 'react-router-dom';
import classNames from 'classnames';
import { ProductsFeatures } from './features';
import { ProductsKeyBenefits } from './key-benefits';
import { ProductsTypicalApplications } from './typical-applications';
import { ProductsHelpGuides } from './help-guides';
import { ProductsNavComponent } from './products-nav';
import { getConfig } from '../../config';
import { AppEnvType } from '../../model';

export const ProductsComponent = () => {
  const [serviceData, setServiceData] = useState<IProductsServiceItem | null>(
    null
  );
  const [configData, setConfigData] = useState<IJsonConfig | null>(null);
  const [typicalActive, setTypicalActive] = useState<number>(0);
  const history = useHistory();
  const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
  const currentURL = window.location.href;
  const urlParts = new URL(currentURL);
  const pathSegments = urlParts.pathname.split('/');
  const productsIndex = pathSegments.indexOf('products');
  const currentUniqueName = pathSegments[productsIndex + 1];
  const toLowerCaseAndRemoveSpaces = (str: string) => {
    return str.toLowerCase().replace(/\s+/g, '');
  };

  useEffect(() => {
    uniqueNameChange();
    setTypicalActive(0);
  }, [currentUniqueName]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  const uniqueNameChange = async () => {
    let currentConfigData = configData;
    const appConfig = getConfig();
    const configUrl = appConfig.cdnURL
      ? `${appConfig.cdnURL}/ingame-website/app-config/${
          appConfig.env === AppEnvType.Production
            ? 'prod-config'
            : 'test-config'
        }/${currentStoreLanguage}.json?t=${Date.now()}`
      : '';
    // if (!currentConfigData) {
    try {
      const response = await fetch(configUrl, {
        cache: 'no-store',
        headers: {
          'Cache-Control': 'no-cache, no-store, must-revalidate',
          Pragma: 'no-cache',
        },
      });
      if (!response.ok) {
        return console.log('error');
      }
      const data = await response.json(); // 解析JSON格式的响应体
      if (data) {
        setConfigData(data);
        currentConfigData = data;
      }
    } catch (error) {
      console.error('There was a problem with your fetch operation:', error);
    }
    // }
    let serviceItem;
    const classifyList = currentConfigData?.serviceConfig
      ? Object.keys(currentConfigData.serviceConfig)
      : [];
    classifyList.forEach((item) => {
      const configDataItem = currentConfigData?.serviceConfig?.[item];
      if (configDataItem) {
        configDataItem.services &&
          configDataItem.services.length !== 0 &&
          configDataItem.services.forEach((it) => {
            if (
              toLowerCaseAndRemoveSpaces(it.uniqueName) ===
              toLowerCaseAndRemoveSpaces(currentUniqueName)
            ) {
              serviceItem = Object.assign({}, it);
            }
          });
      }
    });
    if (serviceItem) {
      setServiceData(serviceItem);
    } else {
      history.push('/');
    }
  };

  const isShow = () => {
    let isShow = false;
    if (
      serviceData?.featuresConfig &&
      serviceData?.featuresConfig?.length !== 0
    ) {
      isShow = true;
    }
    if (
      serviceData?.keyBenefitsConfig &&
      serviceData?.keyBenefitsConfig?.length !== 0
    ) {
      isShow = true;
    }
    if (
      serviceData?.typicalApplicationsConfig &&
      serviceData?.typicalApplicationsConfig?.length !== 0
    ) {
      isShow = true;
    }
    return isShow;
  };

  return (
    <LayoutDefault>
      <>
        <ProductsBanner serviceData={serviceData} />
        {isShow() && (
          <ProductsNavComponent
            serviceData={serviceData}
            uniqueName={currentUniqueName}
          />
        )}
        {serviceData?.featuresConfig &&
          serviceData?.featuresConfig?.length !== 0 && (
            <div className={styles.productsFeaturesBox} id="nav-item-0">
              <div className={styles.productsFeaturesTitle}>
                {getFormatMessage('products_features')}
              </div>
              <div className={styles.productsFeaturesContentBox}>
                {serviceData.featuresConfig.map((item) => {
                  return <ProductsFeatures featuresConfig={item} />;
                })}
              </div>
            </div>
          )}
        {serviceData?.keyBenefitsConfig &&
          serviceData?.keyBenefitsConfig.length !== 0 && (
            <div className={styles.productsKeyBenefitsBox} id="nav-item-1">
              <div className={styles.productsFeaturesTitle}>
                {getFormatMessage('products_key_benefits')}
              </div>
              <ProductsKeyBenefits
                keyBenefitsConfig={serviceData?.keyBenefitsConfig || []}
              />
            </div>
          )}
        {serviceData?.typicalApplicationsConfig &&
          serviceData?.typicalApplicationsConfig?.length !== 0 && (
            <div
              className={styles.productsTypicalApplicationsBox}
              id="nav-item-2"
            >
              <div className={styles.productsTypicalApplicationsBgBox}>
                <div className={styles.productsTypicalApplicationsContentBox}>
                  <div className={styles.productsFeaturesTitle}>
                    {getFormatMessage('products_typical_application')}
                  </div>
                  <div className={styles.typicalApplicationsBox}>
                    {serviceData?.typicalApplicationsConfig &&
                      serviceData?.typicalApplicationsConfig?.length > 1 && (
                        <div className={styles.typicalApplicationsNav}>
                          {serviceData.typicalApplicationsConfig.map(
                            (item, index) => {
                              return (
                                <div
                                  className={classNames(
                                    styles.typicalApplicationsNavItem,
                                    typicalActive === index
                                      ? styles.typicalActive
                                      : ''
                                  )}
                                  onClick={() => setTypicalActive(index)}
                                >
                                  {item.title}
                                </div>
                              );
                            }
                          )}
                        </div>
                      )}
                    <ProductsTypicalApplications
                      typicalApplicationsConfig={
                        serviceData.typicalApplicationsConfig[typicalActive]
                      }
                    />
                  </div>
                  <div className={styles.typicalApplicationsBoxMobile}>
                    {
                      serviceData?.typicalApplicationsConfig &&
                      serviceData?.typicalApplicationsConfig?.length !== 0 && serviceData?.typicalApplicationsConfig.map(item => {
                        return (
                          <ProductsTypicalApplications
                            typicalApplicationsConfig={
                              item
                            }
                          />
                        )
                      })
                    }
                  </div>
                </div>
              </div>
            </div>
          )}
        <div className={styles.productsHelpGuidesBox} id="nav-item-3">
          <div className={styles.productsFeaturesTitle}>
            {getFormatMessage('products_help_guides')}
          </div>
          <ProductsHelpGuides />
        </div>
      </>
    </LayoutDefault>
  );
};
